import H2 from "../components/H2"
import RequestFundingForStartupScaleupForm from "../components/forms/RequestFundingForStartupScaleupForm";
import ContactSidebar from "../components/ContactSidebar"

export default function Contact() {
  return (
    <div className="flex flex-wrap mb-20 lg:mb-32">
      <div className="w-full md:w-2/3">
        <H2 title="Request funding for a startup / scaleup" subtitle="Funding need: €200.000 to €1 million" />
        <RequestFundingForStartupScaleupForm />
      </div>
      <ContactSidebar />
    </div>
  );
}